var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9905 10.6964C19.9905 9.83608 19.9224 9.20824 19.7752 8.55716H10.1992V12.4404H15.8201C15.7068 13.4054 15.0948 14.8588 13.7349 15.8353L13.7159 15.9653L16.7436 18.3718L16.9534 18.3933C18.8798 16.5679 19.9905 13.8821 19.9905 10.6964Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1992 20.9278C12.953 20.9278 15.2648 19.9977 16.9534 18.3932L13.7349 15.8353C12.8737 16.4516 11.7177 16.8817 10.1992 16.8817C7.50211 16.8817 5.21297 15.0564 4.39695 12.5334L4.27734 12.5439L1.12906 15.0436L1.08789 15.161C2.76508 18.5792 6.21016 20.9278 10.1992 20.9278Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.39695 12.5334C4.18164 11.8824 4.05703 11.1847 4.05703 10.4639C4.05703 9.74301 4.18164 9.04544 4.38562 8.39436L4.37992 8.2557L1.19219 5.71582L1.08789 5.76672C0.396641 7.18518 0 8.77805 0 10.4639C0 12.1498 0.396641 13.7425 1.08789 15.161L4.39695 12.5334Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1992 4.04603C12.1144 4.04603 13.4062 4.89476 14.1429 5.60403L17.0213 2.72062C15.2535 1.03477 12.953 0 10.1992 0C6.21016 0 2.76508 2.34855 1.08789 5.76674L4.38563 8.39439C5.21297 5.87142 7.50211 4.04603 10.1992 4.04603Z",
    fill: "#EB4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.be08ac39.svg";
export { ForwardRef as ReactComponent };